// extracted by mini-css-extract-plugin
module.exports = {"readMore":"PastEventsPageTemplate-module--read-more--RUrng","moreEvents":"PastEventsPageTemplate-module--more-events--1Rf51"};